import { Route } from '@common/types/Route';

export enum SidebarSequence {
    DEFAULT = 'right-col',
    PREMIUM_HOMEPAGE = 'premium-homepage',
    RIGHT_COL_ARTICLE = 'right-col-article',
    RIGHT_COL_HOMEPAGE = 'right-col-homepage',
    RIGHT_COL_MEDIA = 'right-col-media',
    RIGHT_COL_MEDIA_INDEX = 'right-col-media-index',
    RIGHT_COL_MISC = 'right-col-misc',
    RIGHT_COL_PODCAST = 'right-col-podcast',
}

type SidebarRouteSequence = {
    [route in Route]?: SidebarSequence;
};

// Routes not listed should fallback to the default sequence.
export const SidebarSequenceByRoute: SidebarRouteSequence = {
    [Route.Article]: SidebarSequence.RIGHT_COL_ARTICLE,
    [Route.BrightPodcast]: SidebarSequence.RIGHT_COL_PODCAST,
    [Route.ClubOverview]: SidebarSequence.RIGHT_COL_MISC,
    [Route.Club]: SidebarSequence.RIGHT_COL_MISC,
    [Route.CompetitionOverview]: SidebarSequence.RIGHT_COL_MISC,
    [Route.Competition]: SidebarSequence.RIGHT_COL_MISC,
    [Route.Homepage]: SidebarSequence.RIGHT_COL_HOMEPAGE,
    [Route.MatchByID]: SidebarSequence.RIGHT_COL_MISC,
    [Route.Podcast]: SidebarSequence.RIGHT_COL_PODCAST,
    [Route.RecentNews]: SidebarSequence.RIGHT_COL_ARTICLE,
    [Route.Premium]: SidebarSequence.PREMIUM_HOMEPAGE,
    [Route.Search]: SidebarSequence.RIGHT_COL_HOMEPAGE,
    [Route.TransferNews]: SidebarSequence.RIGHT_COL_HOMEPAGE,
    [Route.VideoOverview]: SidebarSequence.RIGHT_COL_MEDIA,
};

export const ROUTES_WITHOUT_SIDEBAR_DATA = [
    Route.AttemptRefresh,
    Route.Bookmarks,
    Route.Error,
    Route.ForgotPassword,
    Route.Liveness,
    Route.MyPxr,
    Route.MySubscription,
    Route.Notifications,
    Route.PasswordReset,
    Route.Profile,
    Route.Readiness,
    Route.Settings,
    Route.Signin,
    Route.Signout,
    Route.Subscribe,
    Route.SubscribeFailure,
    Route.SubscribeSuccess,
    Route.SubscribeSwitch,
    Route.VerifyEmail,
];
